<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <v-btn text small @click="$emit('click')" :disabled="disabled" class="action-btn">
                    <v-icon small class="mr-2">{{ icon }}</v-icon>
                    <span>{{ label }}</span>
                </v-btn>
            </div>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
export default {
    props: ['label', 'icon', 'tooltip', 'disabled'],
    emits: ['click']
}
</script>